module.exports = __webpack_public_path__ + "static/player-bg-3d7cae8fbe9d0893bbfbb099b8c86b28.png";